import React, { useState, useEffect, useRef } from 'react';
import { __ } from './../../../tools';
import style from './style.module.scss';

export const ReadMore = (props) => {
    const data = Array.isArray(props.children) ? props.children.join('\n') : props.children;
    const contentRef = useRef(null);
    const [linesCount, setLinesCount] = useState(props.linesCount);
    const [isClamped, setClamped] = useState(false);
    const [isExpanded, setExpanded] = useState(false);

    const handleClick = () => {
        setLinesCount(isExpanded ? props.linesCount : -1);
        setExpanded((val) => !val);
    };

    useEffect(() => {
        if (contentRef && contentRef.current) {
            setClamped(contentRef.current.scrollHeight > contentRef.current.clientHeight);
        }
    }, []);

    return (
        <p>
            <span
                ref={contentRef}
                className={style.truncate}
                style={{ '--lines-count': linesCount ?? 2 }}
                dangerouslySetInnerHTML={{ __html: data }}
            />
            {true === isClamped && (
                <button className={style.button} type="button" onClick={handleClick}>
                    {isExpanded ? __('Voir moins', 'paraboot') : __('Voir plus', 'paraboot')}
                </button>
            )}
        </p>
    );
};

export default ReadMore;
